export default function Twemoji({ emoji, className }) {
  if (!emoji) return null;
  const codePoints = Array.from(emoji)
    .map(c => c.codePointAt(0).toString(16))
    .filter(c => c !== 'fe0f')
    .join('-');
  return (
    <>
      <img
        src={`https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${codePoints}.svg`}
        alt={emoji}
        className={className || 'twemoji'}
        style={{ width: '1.2em', height: '1.2em', verticalAlign: '-0.2em', display: 'inline-block' }}
        onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'inline'; }}
      />
      <span style={{ display: 'none' }}>{emoji}</span>
    </>
  );
}
